module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-3.003228cc.jpg";